import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

export interface PageFooterSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const PageFooter: TOC<PageFooterSignature> = <template>
  <div class="h-[60px] overflow-hidden px-3 py-4 border-t border-gray-200" {{mergeClasses}} ...attributes>
    {{yield}}
  </div>
</template>;

export default PageFooter;
